import React, { useState, useEffect } from "react";

import { Sidebar } from "primereact/sidebar";

import { FaChevronDown } from "react-icons/fa";
import Select, { components } from "react-select";
import { teamIds, teamList, userRole } from "../../../utils/storage";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import { FiCalendar } from "react-icons/fi";
import CustomSelect from "../../common/CustomSelect";
import { getBackgroundClass, interestLevel } from "../../../Enum/LeadEnumConstants";


const BulkLeadUploadHistoryFilter = ({
  selectedLevel,
  handleSelectChange,
  startDate,
  endDate,
  setStartDate,
  setEndDate,
  handleApplyFilter,
  clearFilters,
}) => {
  const onApply = () => {
    handleApplyFilter({ quality: selectedLevel, startDate, endDate });
  };

  return (
    <div className="flex flex-col gap-4 p-4">
      <CustomSelect
        value={selectedLevel}
        placeholder="Select Lead Quality"
        onChange={handleSelectChange}
        options={interestLevel}
        formatOptionLabel={(e) => (
          <div className="flex items-center">
            <img src={e.image} alt={e.label} className="w-6 h-6 mr-2" />
            <span className={`${getBackgroundClass(e.label)} font-bold`}>
              {e.label}
            </span>
          </div>
        )}
      />
   <div className="relative input-focus rounded-md ">
        <DatePicker
          selected={startDate}
          onChange={(date) => setStartDate(date)}
          placeholderText="Start Date"
          maxDate={new Date()}
          dateFormat="dd/MM/yyyy"
           className="w-full focus:outline-none rounded-md   py-2 px-3"
        />
        <FiCalendar className="absolute right-3 top-3 text-gray-500 pointer-events-none" />
      </div>
      <div className="relative input-focus  rounded-md">
        <DatePicker
          selected={endDate}
          onChange={(date) => setEndDate(date)}
          
          placeholderText={`${startDate ? "End Date" : "Select Start Date first"} `}
          minDate={startDate}
          disabled={!startDate}
          maxDate={new Date()}
          dateFormat="dd/MM/yyyy"
          className="w-full focus:outline-none rounded-md   py-2 px-3"
        />
        <FiCalendar className="absolute right-3 top-3 text-gray-500 pointer-events-none" />
      </div>
      <button
        className="bg-customGreen text-white py-2 px-4 rounded-md hover:bg-appGreenHover transition duration-300 w-full mt-4"
        onClick={onApply}
      >
        Apply Filters
      </button>
      <button
        className="bg-white text-customGreen border border-customGreen py-2 px-4 rounded-md hover:bg-gray-100 transition duration-300 w-full"
        onClick={clearFilters}
      >
        Clear Filters
      </button>
    </div>
  );
};

export default BulkLeadUploadHistoryFilter